import { BalanceReportState } from '../models'

/**
 * BALANCE REPORT INITIAL STATE
 */
const initialState: BalanceReportState = {
  isLoading: false,
  hasError: false,
  error: '',
  wasDeleted: false,
  reports: [],
  pagination: {
    total: 0,
    limit: 25,
    page: 1,
    pages: 1,
  },
  filters: {
    playerId: '',
    startDate: '',
    endDate: '',
    page: 1,
    limit: 25,
  },
}

export default initialState
